// How a frozen summary copy is dated (flow/consults/summary_copies.py): a
// send's copy by its send, one rendered later for a summary sent before copies
// existed by its render (Aziz 2026-10-03: "rendered on <date>"). `moment` is
// the app's $moment.
export function summaryCopyCaption (copy, moment) {
    if (!copy || !copy.date) { return '' }
    const day = moment(copy.date).format('MMMM D, YYYY')
    return copy.kind === 'rendered' ? `Rendered on ${day}` : `Sent ${day}`
}

// "today at 11:40 AM", "Oct 14 at 4:25 PM", "Oct 16, 2025 at 2:30 PM": how the
// send dialog and the staff banner date the last send (Aziz 2026-10-16).
export function sentAtText (date, moment, now = moment()) {
    if (!date) { return '' }
    const at = moment(date)
    const time = at.format('h:mm A')
    if (at.isSame(now, 'day')) { return `today at ${time}` }
    return `${at.format(at.isSame(now, 'year') ? 'MMM D' : 'MMM D, YYYY')} at ${time}`
}
